import { Download01 } from '@untitledui/icons';
import { useCallback, useMemo } from 'react';

import { getApiBaseUrl } from '@/lib/config';
import { EntityBadge } from '@/lib/crm/components/badges/EntityBadge';
import { FileSizeValueLabel } from '@/lib/crm/components/properties/labels/FileSizeValueLabel';

interface FileAssociationCardProps {
  entityId: string;
  filename: string;
  fileSize: string | number | null;
  uploadedFileId: string | number | null;
  orgId: string | undefined;
  onOpen?: (entityId: string) => void;
}

const WRAPPER_CLASSES = 'inline-flex items-center gap-1 flex-wrap';
const ENTITY_BADGE_CLASSES = 'inline-flex align-middle';
const VIEW_LINK_CLASSES =
  'inline-flex items-center gap-1 text-xs text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)]';

export function FileAssociationCard({
  entityId,
  filename,
  fileSize,
  uploadedFileId,
  orgId,
  onOpen,
}: FileAssociationCardProps) {
  const handleClick = useCallback(() => {
    onOpen?.(entityId);
  }, [onOpen, entityId]);

  const viewUrl = useMemo(
    () =>
      orgId != null && uploadedFileId != null
        ? `${getApiBaseUrl()}/api/orgs/${orgId}/files/${uploadedFileId}/view/`
        : null,
    [orgId, uploadedFileId]
  );

  return (
    <span className={WRAPPER_CLASSES}>
      <EntityBadge
        state={{
          kind: 'data',
          data: {
            id: entityId,
            entityType: 'ahoy_file',
            displayName: filename,
          },
        }}
        variant='xs'
        className={ENTITY_BADGE_CLASSES}
        onClick={onOpen ? handleClick : undefined}
      />
      <FileSizeValueLabel value={fileSize} fontSize='xs' />
      {viewUrl !== null && (
        <a
          href={viewUrl}
          target='_blank'
          rel='noopener noreferrer'
          className={VIEW_LINK_CLASSES}
        >
          <Download01 />
          View
        </a>
      )}
    </span>
  );
}
